import {
  FileUploaderProps,
  arrayToCommaSeparatedString,
  bytesToHumanReadable,
} from 'ui-components';

import {
  ACCEPTED_FILE_FORMATS,
  MAX_FILE_SIZE,
} from './ImageUploader.constants';

export const validator: FileUploaderProps['validator'] = (file) => {
  if (MAX_FILE_SIZE && file.size > MAX_FILE_SIZE) {
    return {
      code: 'too-large',
      message: `Image file size is too large. Max size is ${bytesToHumanReadable(
        MAX_FILE_SIZE,
      )}.`,
    };
  }

  if (
    ACCEPTED_FILE_FORMATS &&
    !Object.entries(ACCEPTED_FILE_FORMATS).some(([key, value]) => {
      const supportedFileType = value.map((type) => key.replace('*', type));
      return supportedFileType.includes(file.type);
    })
  ) {
    const supportedFileTypes = Object.values(ACCEPTED_FILE_FORMATS).flat();
    return {
      code: 'invalid-type',
      message: `Invalid file format. ${arrayToCommaSeparatedString(
        supportedFileTypes,
        (value) => value.toUpperCase(),
      )} format.`,
    };
  }

  return null;
};
